import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import DashboardLayout from "@/layout/DashboardLayout";
import Overview from "@/pages/Overview";
import Brain from "@/pages/Brain";
import Team from "@/pages/Team";
import Audit from "@/pages/Audit";
import Simulator from "@/pages/Simulator";
import Documents from "@/pages/Documents";
import PendingQuestions from "@/pages/PendingQuestions";
import Integrations from "@/pages/Integrations";
import Agenda from "@/pages/Agenda";
import Campaigns from "@/pages/Campaigns";
import Accounts from "@/pages/Accounts";
import TendersRadar from "@/pages/TendersRadar";
import Setor from "@/pages/Setor";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-muted-foreground">...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="light" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="brain" element={<Brain />} />
              <Route path="team" element={<Team />} />
              <Route path="audit" element={<Audit />} />
              <Route path="simulator" element={<Simulator />} />
              <Route path="documents" element={<Documents />} />
              <Route path="pending" element={<PendingQuestions />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="comercial" element={<Accounts />} />
              <Route path="setor/:key" element={<Setor />} />
              <Route path="licitacoes" element={<TendersRadar />} />
              <Route path="integrations" element={<Integrations />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
